import { HTMLProps, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { PensionContext } from '../../../../contexts/pension-robot/PensionContext';
import { PlusAndMinusPensionAgeButton } from './PlusAndMinusPensionAgeButton';

export const ChangePensionAge: React.FC<{ isGoalAchieved: boolean } & HTMLProps<HTMLDivElement>> = ({ isGoalAchieved }) => {
    const { t } = useTranslation('pension');
    const { parameters: { personalInfo } } = useContext(PensionContext);

    return (
        <div className="p-4 border-b">
            <span>
                {isGoalAchieved 
                    ? t('pension-result-disclosure-change-pension-age-text-goal-achieved')
                    : t('pension-result-disclosure-change-pension-age-text-goal-not-achieved')}
            </span>
            <div className="flex flex-row mt-2">
                <PlusAndMinusPensionAgeButton className="mr-6" />
                {personalInfo.maritalStatus === 'married' && <PlusAndMinusPensionAgeButton isPartnerPension={true} />}
            </div>
        </div>
    );
};
